import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Iconify from 'src/components/iconify';

export default function CandListFilterResult({
  filters,
  onFilters,
  canReset,
  onResetFilters,
  results,
  ...other
}) {
  const handleRemoveStatus = (inputValue) => {
    const newValue = filters.Status.filter((item) => item !== inputValue);
    onFilters('Status', newValue);
  };
  const handleRemoveNm = (inputValue) => {
    const newValue = filters.fname.filter((item) => item !== inputValue);
    onFilters('fname', newValue);
  };
  const handleRemoveEmail = (inputValue) => {
    const newValue = filters.email.filter((item) => item !== inputValue);
    onFilters('email', newValue);
  };
  const handleRemoveSkl = (inputValue) => {
    const newValue = filters.primarySkill.filter((item) => item !== inputValue);
    onFilters('primarySkill', newValue);
  };
  const handleRemoveGender = (inputValue) => {
    const newValue = filters.gender.filter((item) => item !== inputValue);
    onFilters('gender', newValue);
  };
  const handleRemoveExperience = () => {
    onFilters('experience', { from: '', to: '' });
  };
  const handleRemoveSrcHire = (inputValue) => {
    const newValue = filters.sourceOfHire.filter((item) => item !== inputValue);
    onFilters('sourceOfHire', newValue);
  };
  const handleRemoveCandStatus = (inputValue) => {
    const newValue = filters.candStatus.filter((item) => item !== inputValue);
    onFilters('candStatus', newValue);
  };
  const handleRemoveCandCity = (inputValue) => {
    const newValue = filters.city.filter((item) => item !== inputValue);
    onFilters('city', newValue);
  };
  const handleRemoveFormStatus = (inputValue) => {
    const newValue = filters.formStatus.filter((item) => item !== inputValue);
    onFilters('formStatus', newValue);
  };

  return (
    <Stack spacing={1.5} {...other}>
      <Box sx={{ typography: 'body2' }}>
        <strong>{results}</strong>
        <Box component="span" sx={{ color: 'text.secondary', ml: 0.25 }}>
          Records Found
        </Box>
      </Box>
      <Stack flexGrow={1} spacing={1} direction="row" flexWrap="wrap" alignItems="center">
        {!!filters.Status.length && (
          <Block label="Status:">
            {filters.Status.map((item) => (
              <Chip
                key={item}
                label={item}
                size="small"
                onDelete={() => handleRemoveStatus(item)}
              />
            ))}
          </Block>
        )}
        {!!filters.fname.length && (
          <Block label="Candidate Name:">
            {filters.fname.map((item) => (
              <Chip key={item} label={item} size="small" onDelete={() => handleRemoveNm(item)} />
            ))}
          </Block>
        )}
        {!!filters.email.length && (
          <Block label="Candidate Email:">
            {filters.email.map((item) => (
              <Chip key={item} label={item} size="small" onDelete={() => handleRemoveEmail(item)} />
            ))}
          </Block>
        )}
        {!!filters.primarySkill.length && (
          <Block label="Primary Skills:">
            {filters.primarySkill.map((item) => (
              <Chip key={item} label={item} size="small" onDelete={() => handleRemoveSkl(item)} />
            ))}
          </Block>
        )}
        {!!filters.gender.length && (
          <Block label="Gender:">
            {filters.gender.map((item) => (
              <Chip
                key={item}
                label={item}
                size="small"
                onDelete={() => handleRemoveGender(item)}
              />
            ))}
          </Block>
        )}
        {!!filters.experience.from && !!filters.experience.to && (
          <Block label="Experience:">
            <Chip
              label={`${filters.experience.from} - ${filters.experience.to} years`}
              size="small"
              onDelete={handleRemoveExperience}
            />
          </Block>
        )}
        {!!filters.sourceOfHire.length && (
          <Block label="Source Of Hire:">
            {filters.sourceOfHire.map((item) => (
              <Chip
                key={item}
                label={item}
                size="small"
                onDelete={() => handleRemoveSrcHire(item)}
              />
            ))}
          </Block>
        )}
        {!!filters.candStatus.length && (
          <Block label="Candidate Status:">
            {filters.candStatus.map((item) => (
              <Chip
                key={item}
                label={item}
                size="small"
                onDelete={() => handleRemoveCandStatus(item)}
              />
            ))}
          </Block>
        )}
        {!!filters.city.length && (
          <Block label="Current City:">
            {filters.city.map((item) => (
              <Chip
                key={item}
                label={item}
                size="small"
                onDelete={() => handleRemoveCandCity(item)}
              />
            ))}
          </Block>
        )}
        {!!filters.formStatus.length && (
          <Block label="Candidate Form Status:">
            {filters.formStatus.map((item) => (
              <Chip
                key={item}
                label={item}
                size="small"
                onDelete={() => handleRemoveFormStatus(item)}
              />
            ))}
          </Block>
        )}
        {canReset && (
          <Button
            color="error"
            onClick={onResetFilters}
            startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
          >
            Clear
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
CandListFilterResult.propTypes = {
  canReset: PropTypes.bool,
  filters: PropTypes.object,
  onFilters: PropTypes.func,
  onResetFilters: PropTypes.func,
  results: PropTypes.number,
};

function Block({ label, children, sx, ...other }) {
  return (
    <Stack
      component={Paper}
      variant="outlined"
      spacing={1}
      direction="row"
      sx={{
        p: 1,
        borderRadius: 1,
        overflow: 'hidden',
        borderStyle: 'dashed',
        ...sx,
      }}
      {...other}
    >
      <Box component="span" sx={{ typography: 'subtitle2' }}>
        {label}
      </Box>

      <Stack spacing={1} direction="row" flexWrap="wrap">
        {children}
      </Stack>
    </Stack>
  );
}

Block.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  sx: PropTypes.object,
};
